import { Box, Header } from '@amzn/awsui-components-react';

type Props = {
    title: string;
    description?: string;
};

const DrishtiPageHeader = ({ title, description }: Props) => (
    <Box padding={{ bottom: 's' }}>
        <Header variant="h1" description={description}>
            {title}
        </Header>
    </Box>
);

export default DrishtiPageHeader;
